import AIJob from 'models/AIJob';
import { BaseMutationParams } from 'services/api/types';
import http from 'services/http';

export const aiJobQueryKeys = {
  base: ['aiJobs'],
};

type CreateAIJobInput = {
  type: string;
  reviewId?: string;
} & BaseMutationParams;

export const createAIJob = async (input: CreateAIJobInput) => {
  const { include, ...data } = input;
  return http.post<any>('/ai_jobs', data, { params: { include } }).then(
    (response) =>
      new AIJob({
        ...response.data,
        reviewId: response.data.reviewId || undefined,
      })
  );
};
